import React, { useEffect, useMemo, useState, useRef } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import { Menu, Modal, Form, Input, Button, Checkbox, message } from 'antd'
import { UserOutlined, LockOutlined, ExclamationCircleOutlined } from '@ant-design/icons'
import Brand from '@components/Brand'
import styles from './index.less'

const { confirm } = Modal

function Nav(props) {
  // console.log('Nav props', props)
  const { pathname } = useLocation()
  const navigate = useNavigate()
  const [current, setCurrent] = useState('home')
  const [showLoginDialog, setShowLoginDialog] = useState(false)
  const [showRegisterDialog, setShowRegisterDialog] = useState(false)
  const [showAgreementDialog, setShowAgreementDialog] = useState(false)
  const [user, setUser] = useState(null)

  const usernameReg = new RegExp(/^[a-zA-Z]{1}[a-zA-Z0-9]{5,15}$/)

  const userList = JSON.parse(window.localStorage.getItem('USER_LIST'))

  if (`/${current}` !== pathname) {
    setCurrent(pathname.replace('/', ''))
  }

  function handleClick(e) {
    console.log(e.key)
    if (e.key === current) {
      return
    } else if (e.key === 'login') {
      setShowLoginDialog(true)
    } else if (e.key === 'register') {
      setShowRegisterDialog(true)
    } else if (e.key === 'user') {
      confirm({
        title: '是否确认退出登录?',
        icon: <ExclamationCircleOutlined style={{ color: '#FF0000' }} />,
        okText: '确定',
        okType: 'danger',
        cancelText: '取消',
        onOk() {
          setUser(null)
        },
        onCancel() {
          console.log('Cancel')
        },
      })
    } else {
      setCurrent(e.key)
      navigate(`${e.key}`)
    }
  }

  function onLoginFinish(values) {
    console.log('onLoginFinish: ', values)
    const { username, password } = values
    const userData =
      userList.find((item) => {
        return item.username === username
      }) || {}
    if (!usernameReg.test(username)) {
      message.error('用户不存在')
    } else if (password.length < 6 || (userData.password && password !== userData.password)) {
      message.error('密码错误')
    } else {
      setUser({
        username,
        password,
      })
      message.success('登录成功')
      setShowLoginDialog(false)
    }
  }

  function onRegisterFinish(values) {
    console.log('onRegisterFinish', values)
    const userData = values
    userList.push(userData)
    window.localStorage.setItem('USER_LIST', JSON.stringify(userList))
    message.success('注册成功')
    setShowRegisterDialog(false)
    setShowLoginDialog(true)
  }

  return (
    <div className={styles["nav"]}>
      <div className={styles["nav-main"]}>
        <div className={styles["nav-left"]}>
          <Brand />
        </div>
        <div className={styles["nav-right"]}>
          <div className={styles["nav-menu"]}>
            <Menu
              onClick={handleClick}
              selectedKeys={[current]}
              mode="horizontal"
              theme="dark"
              style={{
                justifyContent: "end",
              }}
            >
              <Menu.Item key="home">首页</Menu.Item>
              <Menu.Item key="cartoon">动漫</Menu.Item>
              <Menu.Item key="dispute">纠纷处理</Menu.Item>
              {!user && <Menu.Item key="login">登录</Menu.Item>}
              {!user && <Menu.Item key="register">注册</Menu.Item>}
              {user && (
                <Menu.Item key="user" style={{ width: "200px" }}>
                  {user.username}
                </Menu.Item>
              )}
            </Menu>
          </div>
        </div>
      </div>

      {showLoginDialog && (
        <Modal
          title="登录"
          visible={showLoginDialog}
          destroyOnClose
          onOk={() => {
            setShowLoginDialog(false);
          }}
          onCancel={() => {
            setShowLoginDialog(false);
          }}
          footer={[]}
        >
          <Form
            name="normal_login"
            className={styles["login-form"]}
            initialValues={{ remember: true }}
            onFinish={onLoginFinish}
          >
            <Form.Item
              name="username"
              rules={[{ required: true, message: "请输入用户名！" }]}
            >
              <Input prefix={<UserOutlined />} placeholder="请输入用户名" />
            </Form.Item>
            <Form.Item
              name="password"
              rules={[{ required: true, message: "请输入密码！" }]}
            >
              <Input
                prefix={<LockOutlined />}
                type="password"
                placeholder="请输入密码"
              />
            </Form.Item>
            <Form.Item>
              <Form.Item
                name="agreement"
                valuePropName="checked"
                noStyle
                rules={[
                  {
                    validator: (_, value) =>
                      value
                        ? Promise.resolve()
                        : Promise.reject(
                            new Error(
                              "请阅读并同意《武汉风行在线技术有限公司用户协议》！"
                            )
                          ),
                  },
                ]}
              >
                <Checkbox>
                  我接受
                  <Button
                    type="link"
                    onClick={() => {
                      setShowAgreementDialog(true);
                    }}
                  >
                    《武汉风行在线技术有限公司用户协议》
                  </Button>
                </Checkbox>
              </Form.Item>
            </Form.Item>

            <Form.Item>
              <Button
                type="primary"
                htmlType="submit"
                className={styles["login-form-button"]}
              >
                登录
              </Button>
            </Form.Item>
          </Form>
        </Modal>
      )}

      {showRegisterDialog && (
        <Modal
          title="注册"
          visible={showRegisterDialog}
          destroyOnClose
          onOk={() => {
            setShowRegisterDialog(false);
          }}
          onCancel={() => {
            setShowRegisterDialog(false);
          }}
          footer={[]}
        >
          <Form
            name="normal_login"
            className={styles["login-form"]}
            initialValues={{ remember: true }}
            onFinish={onRegisterFinish}
          >
            <Form.Item
              name="username"
              rules={[
                { required: true, message: "请输入用户名！" },
                { pattern: usernameReg, message: "请输入正确的用户名！" },
                ({ getFieldValue }) => ({
                  validator(_, value) {
                    if (
                      userList.findIndex((item) => {
                        return item.username === value;
                      }) === -1
                    ) {
                      return Promise.resolve();
                    }
                    return Promise.reject(new Error("用户已注册！"));
                  },
                }),
              ]}
            >
              <Input
                prefix={<UserOutlined />}
                placeholder="请输入用户名(6-16位)"
              />
            </Form.Item>
            <Form.Item
              name="password"
              rules={[
                { required: true, message: "请输入密码！" },
                {
                  type: "string",
                  min: 6,
                  max: 16,
                  message: "密码长度最小6位！",
                },
              ]}
            >
              <Input.Password
                prefix={<LockOutlined />}
                type="password"
                placeholder="请输入密码(6-16位)"
              />
            </Form.Item>
            <Form.Item
              name="confirm"
              dependencies={["password"]}
              hasFeedback
              rules={[
                {
                  required: true,
                  message: "请再次输入密码！",
                },
                { type: "string", min: 6, message: "密码长度最小6位！" },
                ({ getFieldValue }) => ({
                  validator(_, value) {
                    if (!value || getFieldValue("password") === value) {
                      return Promise.resolve();
                    }
                    return Promise.reject(new Error("两次输入的密码不一致!"));
                  },
                }),
              ]}
            >
              <Input.Password
                prefix={<LockOutlined />}
                placeholder="请再次输入密码"
              />
            </Form.Item>

            <Form.Item>
              <Form.Item
                name="agreement"
                valuePropName="checked"
                noStyle
                rules={[
                  {
                    validator: (_, value) =>
                      value
                        ? Promise.resolve()
                        : Promise.reject(
                            new Error(
                              "请阅读并同意《武汉风行在线技术有限公司用户协议》！"
                            )
                          ),
                  },
                ]}
              >
                <Checkbox>
                  我接受
                  <Button
                    type="link"
                    onClick={() => {
                      setShowAgreementDialog(true);
                    }}
                  >
                    《武汉风行在线技术有限公司用户协议》
                  </Button>
                </Checkbox>
              </Form.Item>
            </Form.Item>

            <Form.Item>
              <Button
                type="primary"
                htmlType="submit"
                className={styles["login-form-button"]}
              >
                注册
              </Button>
            </Form.Item>
          </Form>
        </Modal>
      )}

      <Modal
        title="武汉风行在线技术有限公司用户协议"
        visible={showAgreementDialog}
        width="1000px"
        closable={false}
        footer={[
          <Button
            type="primary"
            key="confirm"
            onClick={() => {
              setShowAgreementDialog(false);
            }}
          >
            确定
          </Button>,
        ]}
      >
        {Agreement}
      </Modal>
    </div>
  );
}

const Agreement = (
  <div className={styles['agreement-main']}>
    <h1>武汉风行在线技术有限公司用户协议</h1>
    <h3>一．特别提示</h3>
    <p>
      武汉风行在线技术有限公司（以下简称“风行”） 同意按照本协议的规定及发布的操作规则提供基于互联网的相关服务，
      服务使用人(以下称“用户”)同意本协议的全部条款并按照页面上的提示完成全部的注册程序。用户在进行注册程序过程中点击“同意”按钮即表示用户完全接受本协议项下的全部条款。
      本协议下的条款可由风行在线技术有限变更，条款变更风行在线技术有限将提前60天进行条款变更通知，协议条款一旦发生变动，风行在线技术有限将会在
      风行在线技术有限相关的页面上提示变更内容。用户如不同意风行在线技术有限对本协议的所做的条款变更，应立即停止使用风行在线技术有限提供的服务。
    </p>
    <p>如果您未满18周岁，请在法定监护人的陪同下阅读本协议， 并特别注意未成年人适用条款。</p>
    <h3>二．本协议甲方为武汉风行在线技术有限公司，乙方为风行在线技术有限用户。</h3>
    <h4>1.账号注册</h4>
    <p>
      1.1
      乙方承诺以其真实身份注册成为甲方的用户，并保证所提供的个人身份资料信息真实、完整、有效，依据法律规定和必备条款约定对所提供的信息承担相应的法律责任。
    </p>
    <p>1.2 乙方以其真实身份注册成为甲方用户后，需要修改所提供的个人身份资料信息的，甲方应当及时、有效地为其提供该项服务。</p>
    <h4>2.用户账号使用与保管</h4>
    <p>
      2.1 根据必备条款的约定，甲方有权审查乙方注册所提供的身份信息是否真实、有效，并应积极地采取技术与管理等合
      理措施保障用户账号的安全、有效；乙方有义务妥善保管其
      账号及密码，并正确、安全地使用其账号及密码。任何一方未尽上述义务导致账号密码遗失、账号被盗等情形而给乙方和他人的民事权利造成损害的，应当承担由此产生的法律责任。
    </p>
    <p>2.2乙方对其所持账号依法享有相关权利，并对其行为承担相应的责任。</p>
    <p>产生的行为依法享有权利和承担责任。</p>
    <p>
      2.3 乙方发现其账号或密码被他人非法使用或有使用异常的情况，应及时根据甲方公布的处理方式通知甲方，并有权通知甲方采取措施暂停该账号的登录和使用。
    </p>
    <p>2.4 甲方根据乙方的通知采取措施暂停乙方账号的登录和使用的，甲方应当要求乙方提供并核实与其注册身份信息相一致的个人有效身份信息。</p>
    <p>2.4.1 甲方核实乙方所提供的个人有效身份信息与所注册的身份信息相一致的，应当及时采取措施暂停乙方账号的登录和使用。</p>
    <p>2.4.2 甲方违反2.4.1款项的约定，未及时采取措施暂停乙方账号的登录和使用，因此而给乙方造成损失的，应当承担其相应的法律责任。</p>
    <p>2.4.3 乙方没有提供其个人有效身份证件或者乙方提供的个人有效身份证件与所注册的身份信息不一致的，甲方有权拒绝乙方上述请求。</p>
    <p>
      2.5
      乙方为了维护其合法权益，向甲方提供与所注册的身份信息相一致的个人有效身份信息时，甲方应当为乙方提供账号注册人证明、原始注册信息等必要的协助和支持，并根据需要向有关行政机关和司法机关提供相关证据信息资料。
    </p>
    <h4>3.服务的中止与终止</h4>
    <p>3.1乙方有发布违法信息、严重违背社会公德以及其他违反法律禁止性规定的行为，甲方应当立即终止对乙方提供服务。</p>
    <p>
      3.2乙方在接受甲方服务时实施不正当行为的，甲方有权终止对乙方提供服务。该不正当行为的具体情形应当在本协议中有明确约定或属于甲方事先明确告知的应被终止服务的禁止性行为，否则，甲方不得终止对乙方提供服务。
    </p>
    <p>
      3.3乙方提供虚假注册身份信息，或实施违反本协议的行为
      ，甲方有权中止对乙方提供全部或部分服务；甲方采取中止措施应当通知乙方并告知中止期限，中止期限应该是合理的
      ，中止期限届满甲方应当及时恢复对乙方的服务。
    </p>
    <p>3.4 甲方根据本条约定中止或终止对乙方提供部分或全部服务的，甲方应负举证责任。</p>
    <h4>4.用户信息保护</h4>
    <p>
      4.1
      甲方要求乙方提供与其个人身份有关的信息资料时，应当事先以明确而易见的方式向乙方公开其隐私权保护政策和个人信息利用政策，并采取必要措施保护乙方的个人信息资料的安全。
    </p>
    <p>
      4.2未经乙方许可甲方不得向任何第三方提供、公开或共享乙方注册资料中的姓名、个人有效身份证件号码、联系方式
      、家庭住址等个人身份信息，但下列情况除外：
    </p>
    <p>4.2.1 乙方或乙方监护人授权甲方披露的；</p>
    <p>4.2.2 有关法律要求甲方披露的；</p>
    <p>4.2.3 司法机关或行政机关基于法定程序要求甲方提供的；</p>
    <p>4.2.4 甲方为了维护自己合法权益而向乙方提起诉讼或者仲 裁时；</p>
    <p>4.2.5 应乙方监护人的合法要求而提供乙方个人身份信息时 。</p>
    <h3>三．其他</h3>
    <h4>5. 服务内容</h4>
    <p>
      5.1 风行在线技术有限服务的具体内容由风行在线技术有限根据实际情况提供 ，例如论坛(BBS)、聊天室、电子邮件、发表资讯评论等。
      风行在线技术有限保留变更、中止或终止部分或全部网络服务的权利，对于变更、中止或终止服务风行在线技术有限将会提前180天进行公示通知。
    </p>
    <p>
      5.2 风行在线技术有限在提供网络服务时，可能会对部分网络服务的用户收取一定的费用
      。在此情况下，风行在线技术有限会在相关页面上做明确的提示。如用户不同意支付该等费用，则可不接受相关的网络服务。
    </p>
    <p>
      5.3 用户理解：风行在线技术有限仅提供相关的网络服务，除此之外与相关网络服务有关的设备(如电脑、调制解调器及其他与
      接入互联网有关的装置)及所需的费用(如为接入互联网而支付的电话费及上网费)均应由用户自行负担。
    </p>
    <p>5.4 用户应使用正版软件接受网络服务。</p>
    <h4>6. 免责声明</h4>
    <p>6.1 风行在线技术有限不保证以下事宜：</p>
    <p>本服务将符合您的要求，本服务将不受干扰、及时提供、安全可靠或不会出错 。</p>
    <p>
      6.2
      用户明确同意其使用风行在线技术有限服务所存在的风险将完全由其自己承担；因其使用风行在线技术有限服务而产生的一切后果也由其自己承担，风行在线技术有限对用户不承担任何责任。
    </p>
    <h4>7.违约赔偿</h4>
    <p>
      7.1
      用户同意保障和维护风行在线技术有限及其他用户的利益，如因用户违反有关法律、法规或本协议项下的任何条款而给风行在线技术有限或任何其他第三人造成损失，用户同意承担由此造成的损害赔偿责任。
    </p>
    <h4>8.法律管辖</h4>
    <p>8.1 本协议的订立、执行和解释及争议的解决均应适用中华人民共和国法律。</p>
    <p>8.2 如双方就本协议内容或其执行发生任何争议，双方应尽量友好协商解决；协商不成时，任何一方均可向人民法院提起诉讼。</p>
    <h4>9.通知和送达</h4>
    <p>9.1 本协议项下所有的通知均可通过页面公告、电子邮件或常规的信件传送等方式送达至用户；该通知发出之后即视为用户当时已成功接收。</p>
    <h4>10. 其他规定</h4>
    <p>10.1 本协议构成双方对本协议之约定事项及其他有关事宜的完整协议，除本协议规定的之外，未赋予本协议各方其他权利。</p>
    <p>10.2 如本协议中的任何条款无论因何种原因完全或部分无效或不具有执行力，本协议的其余条款仍应有效并且有约束力 。</p>
    <p>
      10.3
      本协议中的标题仅为方便而设，不具法律或契约效果。特别声明：我国《合同法》第39条规定：采用格式条款订立合同的，提供格式条款的一方应当遵循公平原则确定当事人之间的权利和义务，并采取合理的方式提请对方注意免除或者限制其责任的条款，按照对方的要求，对该条款予以说明。
    </p>
    <p>
      风行在线技术有限在此依法做出特别声明如下： 双方确认上述条款非属于《合同法》第40条规定的“免除其责任、加重对方责任、排除对方主要权利的”的条款
      ，风行在线技术有限尊重用户的权利尤其是诉讼的权利，风行在线技术有限在尊重用户诉讼权利的同时建议诉讼管辖地法院双向（风行在线技术有限在地或用户所在地）所在地法院，而用户选择同意合同并使用服务即视为双方对此约定达成了一致意见。
      用户如有任何需要说明条款的要求，请立即停止使用服务，同时立即致电或发送邮件至风行在线技术有限客服，若用户未致电或发送有说明条款要求的邮件至风行在线技术有限而选择同意该协议，
      则双方在此确认风行在线技术有限已依法履行了根据用户要求对相关条款进行说明的法定义务，风行在线技术有限已给予用户充足的时间与充分的选择权来决定是否缔结本协议。
      鉴于风行在线技术有限已依法明确了上述条款、履行了格式条款制订方的义务，用户点击同意或下一步，将被视为且应当被视为用户已经完全注意并同意了本协议。
    </p>
    <p style={{ textAlign: 'right' }}>武汉风行在线技术有限公司 2022年01月20日</p>
  </div>
)

export default Nav
